export enum PaperSize {
  MM80 = 'MM80',
  MM57 = 'MM57',
}
